export default __webpack_public_path__ + "static/media/screencapture-gym-master-13ed6-web-app-2021-10-02-22_35_37.5c0f8d2c.png";